<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("orderCancellation", ["setCancellationAction"])
  },

  computed: {
    ...mapGetters("orderCancellation", [
      "isCancellation",
      "isCancellationPossible"
    ])
  }
};
</script>

<template>
  <div>
    <div class="alert">
      <p>O que você deseja fazer com o seu pedido?</p>
    </div>

    <div class="actions">
      <template v-if="!isCancellationPossible">
        <button class="btn bg-purple" @click="setCancellationAction('cancel')">
          <span>Cancelar agendamento</span>
        </button>
      </template>

      <template v-else>
        <button class="btn bg-purple" v-if="!isCancellation" @click="setCancellationAction('inform-absence')">
          <span>Informar falta do profissional</span>
        </button>

        <button class="btn bg-purple" v-if="!isCancellation" @click="setCancellationAction('reschedule')">
          <span>Reagendar (inclusive para o mesmo dia)</span>
        </button>

        <button class="btn bg-purple" @click="setCancellationAction('credit')">
          <span>Cancelar e deixar como crédito para ser reagendada no futuro</span>
        </button>

        <button class="btn bg-purple" @click="setCancellationAction('cancel')">
          <span>Cancelar e solicitar o reembolso</span>
        </button>
      </template>

    </div>
  </div>
</template>

<style scoped>
.alert {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.alert > p {
  margin: 0;
  font-weight: 400;
  font-size: 14px;
}

.alert > p:not(:first-child) {
  margin-top: 8px;
}

.alert > .or {
  font-weight: 300;
  font-style: italic;
}

.actions {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.actions > * {
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Actions/Cancellation/CancellationType.vue